document.querySelectorAll('.shoes .product').forEach(images => {
    images.addEventListener('touchstart', handleTouchStart, false);        
    images.addEventListener('touchmove', handleTouchMove, false);
})
var xDown = null;                                                        
var yDown = null;

function getTouches(evt) {
  return evt.touches ||             // browser API
         evt.originalEvent.touches; // jQuery
}                                                     

function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];                                      
    xDown = firstTouch.clientX;                                      
    yDown = firstTouch.clientY;                                      
};                                                

function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if ( xDiff > 0 ) {
            /* left swipe */ 
            document.querySelectorAll('.shoes .product').forEach((area) => {
                $(area).children('.firstImg').css('visibility', 'visible');
                $(area).children('.firstImg').css('opacity', '1');
                $(area).children('.secondImg').css('visibility', 'hidden');
                $(area).children('.secondImg').css('opacity', '0');
                
            })
            $(evt.target).parent().children('img').css('visibility', 'visible');
            $(evt.target).parent().children('img').css('opacity', '1');
            $(evt.target).css('visibility', 'hidden');
            $(evt.target).css('opacity', '0');
        } else {
            /* right swipe */
            document.querySelectorAll('.shoes .product').forEach((area) => {
                $(area).children('.firstImg').css('visibility', 'visible');
                $(area).children('.firstImg').css('opacity', '1');
                $(area).children('.secondImg').css('visibility', 'hidden');
                $(area).children('.secondImg').css('opacity', '0');
                
            })
            $(evt.target).parent().children('img').css('visibility', 'visible');
            $(evt.target).parent().children('img').css('opacity', '1');
            $(evt.target).css('visibility', 'hidden');
            $(evt.target).css('opacity', '0');
        }                       
    } else {
        if ( yDiff > 0 ) {
            /* up swipe */ 
        } else { 
            /* down swipe */
        }                                                                 
    }
    /* reset values */
    xDown = null;
    yDown = null;                                             
};
